import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/fields/add/import')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/fields/add/import"!</div>
}
